export default __webpack_public_path__ + "static/media/4237.da25f6db.png";